















































































































































































import { Component, Vue } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";

@Component
export default class DashboardKepatuhanJatuh extends Vue {
  tahun = new Date().getFullYear();

  get store() {
    return KepatuhanJatuhStore;
  }

  get data() {
    return this.store.dashboardData;
  }

  get tahunOpts() {
    const now = new Date().getFullYear();
    return [now, now - 1, now - 2];
  }

  get totalSesi() {
    return this.store.sessions.filter((s: any) => s.status === "published")
      .length;
  }

  get avgCapaian() {
    const pub = this.store.sessions.filter(
      (s: any) => s.status === "published"
    );
    if (pub.length === 0) return "0.00";
    const sum = pub.reduce(
      (a: number, s: any) => a + Number(s.capaian_pct || 0),
      0
    );
    return (sum / pub.length).toFixed(2);
  }

  get avgClass() {
    const a = Number(this.avgCapaian);
    if (a >= 100) return "success--text";
    if (a >= 95) return "light-green--text";
    if (a >= 80) return "orange--text";
    return "red--text";
  }

  get totalKejadian() {
    return this.store.sessions.filter((s: any) => s.ada_kejadian_jatuh).length;
  }

  get rtlCounts() {
    const def = { open: 0, in_progress: 0, overdue: 0, closed: 0 };
    return (this.data && (this.data as any).rtl_counts) || def;
  }

  get komponenGagal() {
    const def = {
      assessment_awal: 0,
      assessment_ulang: 0,
      monitoring_intervensi: 0
    };
    return (this.data && (this.data as any).komponen_gagal) || def;
  }

  get trenCapaian() {
    return (this.data && (this.data as any).tren_capaian) || [];
  }

  get kejadianPerBulan() {
    return (this.data && (this.data as any).kejadian_jatuh_per_bulan) || [];
  }

  async mounted() {
    await this.load();
  }

  async load() {
    await Promise.all([
      this.store.fetchDashboard(this.tahun),
      this.store.fetchList({ tahun: this.tahun })
    ]);
  }

  namaBulan(b: number) {
    const arr = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ];
    return arr[b - 1] || String(b);
  }

  trendClass(pct: number) {
    if (pct >= 100) return "success--text font-weight-bold";
    if (pct >= 95) return "light-green--text";
    if (pct >= 80) return "orange--text";
    return "red--text";
  }
}
